import { useEffect, useState } from 'react';

// Single source of truth for width-based responsive checks in the site builder
// (replaces the duplicated useNarrow / useIsMobile hooks). Returns true while the
// window is narrower than `px`.
export function useBelow(px: number): boolean {
  const [below, setBelow] = useState(() => typeof window !== 'undefined' && window.innerWidth < px);
  useEffect(() => {
    const onResize = () => setBelow(window.innerWidth < px);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [px]);
  return below;
}
